import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PoliticaPrivacidad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-32 md:py-40">

        <div className="mb-14">
          <span className="text-[#c9a96e] text-[10px] uppercase tracking-[0.3em] font-semibold" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight mt-4 text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Política de Privacidad
          </h1>
          <div className="w-12 h-[2px] bg-[#c9a96e] mt-6" />
        </div>

        <div className="space-y-10 text-[#f8f6f3]/60 text-sm leading-[1.9]" style={{ fontFamily: "'Manrope', sans-serif" }}>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>1. Responsable del tratamiento</h2>
            <ul className="space-y-1 pl-4 border-l-2 border-[#c9a96e]/30">
              <li><strong>Identidad:</strong> A.F. Puertos, S.L.</li>
              <li><strong>CIF:</strong> B29860566</li>
              <li><strong>Dirección:</strong> Calle Gerald Brenan, 39, 1B, 29120 Alhaurín el Grande, Málaga</li>
              <li><strong>Teléfono:</strong> 952 490 400</li>
              <li><strong>Email:</strong> info@afpuertos.com</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>2. Datos que recabamos</h2>
            <p>A través del formulario de contacto del Sitio Web recabamos los siguientes datos personales:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Nombre y apellidos</li>
              <li>Dirección de correo electrónico</li>
              <li>Número de teléfono (opcional)</li>
              <li>Área de consulta y mensaje libre</li>
            </ul>
            <p>No se recaban datos especialmente protegidos ni datos de menores de 14 años. Si usted es menor de dicha edad, no utilice el formulario de contacto.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>3. Finalidad y base jurídica del tratamiento</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-[#c9a96e]/20 text-[#f8f6f3]">
                    <th className="text-left p-3 font-medium">Finalidad</th>
                    <th className="text-left p-3 font-medium">Base jurídica</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-[#f8f6f3]/10">
                    <td className="p-3">Atender y responder su consulta o solicitud de información</td>
                    <td className="p-3">Interés legítimo y consentimiento del interesado (art. 6.1.a y 6.1.f RGPD)</td>
                  </tr>
                  <tr className="border-b border-[#f8f6f3]/10 bg-[#f8f6f3]/5">
                    <td className="p-3">Gestión de la relación comercial y prestación de servicios de asesoría</td>
                    <td className="p-3">Ejecución de un contrato o relación precontractual (art. 6.1.b RGPD)</td>
                  </tr>
                  <tr className="border-b border-[#f8f6f3]/10">
                    <td className="p-3">Cumplimiento de obligaciones legales (fiscales, laborales, contables)</td>
                    <td className="p-3">Obligación legal (art. 6.1.c RGPD)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>4. Destinatarios de los datos</h2>
            <p>Los datos personales no serán cedidos ni comunicados a terceros, salvo en los siguientes supuestos:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Cuando exista obligación legal (p. ej., Agencia Tributaria, Tesorería General de la Seguridad Social).</li>
              <li>Proveedores de servicios tecnológicos que actúen como encargados del tratamiento y que han suscrito el correspondiente contrato de encargo conforme al art. 28 RGPD.</li>
            </ul>
            <p>No se realizan transferencias internacionales de datos a países fuera del Espacio Económico Europeo.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>5. Plazo de conservación</h2>
            <p>Los datos se conservarán durante el tiempo necesario para atender su solicitud y, en su caso, durante la vigencia de la relación contractual. Una vez finalizada esta, los datos se mantendrán debidamente bloqueados durante los plazos de prescripción legales aplicables (con carácter general, 5 años para obligaciones civiles y mercantiles; 4 años para obligaciones tributarias).</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>6. Derechos de los interesados</h2>
            <p>En cualquier momento puede ejercer los siguientes derechos ante A.F. Puertos, S.L., dirigiéndose por escrito a <strong>info@afpuertos.com</strong> o a la dirección postal indicada:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Acceso:</strong> conocer qué datos personales tratamos sobre usted.</li>
              <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
              <li><strong>Supresión:</strong> solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
              <li><strong>Oposición:</strong> oponerse al tratamiento basado en interés legítimo.</li>
              <li><strong>Limitación:</strong> solicitar la restricción del tratamiento en determinadas circunstancias.</li>
              <li><strong>Portabilidad:</strong> recibir sus datos en formato estructurado y legible.</li>
            </ul>
            <p>Asimismo, tiene derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#c9a96e] hover:underline">www.aepd.es</a> si considera que el tratamiento no se ajusta a la normativa vigente.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>7. Medidas de seguridad</h2>
            <p>A.F. Puertos, S.L. ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad e integridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, de acuerdo con lo establecido en el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium text-[#f8f6f3]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>8. Actualización de la política</h2>
            <p>A.F. Puertos, S.L. se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales. Cualquier modificación será publicada en esta página con la fecha de actualización correspondiente.</p>
          </section>

          <div className="pt-6 border-t border-[#f8f6f3]/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
            <p className="text-xs text-[#f8f6f3]/30">Última actualización: marzo de 2026</p>
            <Link to="/aviso-legal" className="text-xs text-[#c9a96e] hover:underline">Ver Aviso Legal →</Link>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  );
}
